import { defineTenant } from './theme/config'
export default defineTenant({
  brand: {
    name: 'Bank of Maldives',
    logo: {
      light:
        'https://cdn.magicpatterns.com/uploads/9MzwaKeaa9a8E4Z8qTAD4X/bml-logo.svg',
      dark: 'https://cdn.magicpatterns.com/uploads/9MzwaKeaa9a8E4Z8qTAD4X/bml-logo.svg',
    },
    favicon:
      'https://cdn.magicpatterns.com/uploads/9MzwaKeaa9a8E4Z8qTAD4X/bml-logo.svg',
  },
  locale: {
    default: 'en-US',
    supported: ['en-US'],
    timezone: 'Indian/Maldives',
  },
  currency: {
    code: 'MVR',
  },
})
